export const sizePerPageList = [
    { text: '10', value: 10 },
    { text: '20', value: 20 },
    { text: '50', value: 50 },
];

export const initialFilter = {
    filter: {
        thk_livestock_uuid: '',
        thk_area_uuid: '',
        kurban_hid: '',
        status: '',
        start_date: '',
        end_date: '',
        status_includes: ["REPORTED", "FINISH"]
    },
    pageNumber: 1,
    pageSize: 10,
    sortField: "created_at",
    sortOrder: "DESC"
};

export const queryStringMaker = (kurban_hid, thk_area_uuid, thk_livestock_uuid, status, start_date, end_date, pageNumber, pageSize, sortField, sortOrder) => {
    return `/kurban-report?kurban_hid=${kurban_hid ?? ""}&thk_area_uuid=${thk_area_uuid ?? ""}&thk_livestock_uuid=${thk_livestock_uuid ?? ""}&status=${status ?? ""}&start_date=${start_date ?? ""}&end_date=${end_date ?? ""}&page=${pageNumber ?? ""}&page_size=${pageSize ?? ""}&sortField=${sortField ?? ""}&sortOrder=${sortOrder ?? ''}`
}


export const KurbanReportStatusBadge = {
    "WAITING_PARTNER": { text: "Belum Di Proses", type: 'warning' },
    "ACCEPTED_PARTNER": { text: "Siap Potong", type: 'info' },
    "EXECUTED": { text: "Terpotong", type: 'dark' },
    "REPORTED": { text: "Laporan Potong", type: 'primary' },
    "FINISH": { text: 'FINISH', type: 'success' }

};



export const kurbanReportStatus = [
    { value: "WAITING_PARTNER", text: "Siap Potong" },
    { value: "ACCEPTED_PARTNER", text: "Belum Di Proses" },
    { value: "EXECUTED", text: "Terpotong" },
    { value: "REPORTED", text: "Laporan Potong" },
    { value: "FINISH", text: "FINISH" },
]

export const kurbanReportReportedStatus = [
    { value: "REPORTED", text: "Laporan Potong" },
    { value: "FINISH", text: "FINISH" },
]

export const kurbanReportStatusKeys = {
    WAITING_PARTNER: "WAITING_PARTNER",
    ACCEPTED_PARTNER: "ACCEPTED_PARTNER",
    EXECUTED: "EXECUTED",
    REPORTED: "REPORTED",
    FINISH: "FINISH",
}

export const tipeHewan = [
    { value: "SAPI", text: "Sapi" },
    { value: "17_SAPI", text: "1/7 Sapi" },
    { value: "KAMBING", text: "Kambing" },
]